import React from "react";
import LegalPage, { DocSections } from "@/pages/legal/LegalPage";
import { PROHIBITED } from "@/pages/legal/_content";

const ProhibitedItems = () => <LegalPage doc={PROHIBITED}><DocSections sections={PROHIBITED.sections}/></LegalPage>;
export default ProhibitedItems;
